import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import '../App.css';

/**
 * Landing page for the password-reset email link.
 *
 * Apple's universal-link rule of thumb: if the iOS app is installed and
 * the associated-domains file matches, tapping the link in Mail will open
 * the app directly and this page never renders. We only get here when:
 *   - the user opened the email on desktop, or
 *   - the app isn't installed on the iOS device.
 *
 * In both cases the only useful action is "open the app to finish". So we
 * deep-link the universal URL back through `window.location` (which on
 * iOS pulls open the app if installed) and otherwise point at the App
 * Store.
 */
function Reset() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [autoTried, setAutoTried] = useState(false);

  useEffect(() => {
    if (!token || autoTried) return;
    // Give the OS a moment to claim the universal link before showing the
    // fallback CTA. If iOS doesn't intercept the navigation, we just stay
    // on the page.
    const t = window.setTimeout(() => setAutoTried(true), 1500);
    return () => window.clearTimeout(t);
  }, [token, autoTried]);

  return (
    <>
      <div className="legal-header">
        <div className="legal-header-inner">
          <Link to="/" style={{ fontWeight: 800, fontSize: 20, color: 'var(--primary)' }}>Gardeno</Link>
          <Link to="/" style={{ fontWeight: 600, fontSize: 14, color: 'var(--primary)' }}>Back to Home</Link>
        </div>
      </div>
      <div className="legal-content" style={{ textAlign: 'center', maxWidth: 480 }}>
        <h1 style={{ marginBottom: 12 }}>Reset your password</h1>
        {!token ? (
          <p style={{ marginTop: 24 }}>
            This link is missing a token. Please request a new reset email from inside the Gardeno app.
          </p>
        ) : (
          <>
            <p className="updated" style={{ marginBottom: 32 }}>
              Open the Gardeno app to finish resetting your password.
            </p>
            <a
              href={`https://gardenoai.com/reset?token=${encodeURIComponent(token)}`}
              style={{
                display: 'inline-block',
                background: 'var(--primary)',
                color: '#fff',
                padding: '14px 28px',
                borderRadius: 100,
                fontWeight: 700,
                fontSize: 15,
                textDecoration: 'none',
                marginBottom: 16,
              }}
            >
              Open in Gardeno
            </a>
            <p style={{ fontSize: 14, color: 'var(--text-secondary)', marginTop: 24 }}>
              Don't have the app? <a href="https://apps.apple.com/gb/app/gardeno-plant-identifier/id6767298062" style={{ color: 'var(--primary)', fontWeight: 700 }}>Download Gardeno</a> and open this email from your iPhone.
            </p>
            <p style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: 32 }}>
              For your security, reset links expire 30 minutes after they're sent.
            </p>
          </>
        )}
      </div>
      <div className="legal-footer">© Gardeno · USTACK GLOBAL (SMC-PRIVATE) LIMITED</div>
    </>
  );
}

export default Reset;
